import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

interface DocumentReviewActionsSignature {
  Element: HTMLDivElement;
  Args: {
    onApprove: () => void;
    onDeny: () => void;
    approveDisabled?: boolean;
    denyDisabled?: boolean;
    /** Phone sticky-bar look: Deny left and narrower, Approve right, larger, no icons. */
    stickyBar?: boolean;
  };
}

// Approve/deny pair: inline in the review card (sm and up), and in the preview modal's phone bar.
export default class DocumentReviewActions extends Component<DocumentReviewActionsSignature> {
  get containerClass(): string {
    return this.args.stickyBar ? 'flex flex-row gap-x-4' : 'flex gap-4';
  }

  get approveClass(): string {
    if (this.args.stickyBar) {
      return 'btn btn--small btn--outline min-w-0 flex-[2] !bg-cilantro-50 !text-white !px-4 !py-[14px]';
    }
    return 'ui-button btn btn--small btn--outline w-full !bg-white';
  }

  get denyClass(): string {
    if (this.args.stickyBar) {
      return 'btn btn--small btn--outline min-w-0 flex-1 order-first !bg-white !text-red-50 !px-4 !py-[14px] !ring-1 !ring-inset !ring-red-50/50';
    }
    return 'ui-button btn btn--small btn--outline w-full !bg-white';
  }

  <template>
    <div class={{this.containerClass}} data-test-document-actions ...attributes>
      <button
        class={{this.approveClass}}
        data-test-approve-button
        disabled={{@approveDisabled}}
        type="button"
        {{on "click" @onApprove}}
      >
        {{#unless @stickyBar}}
          {{svgJar "checkmark-green" width="16" height="16" class="flex-none mr-2 align-middle"}}
        {{/unless}}
        Approve
      </button>
      <button
        class={{this.denyClass}}
        data-test-deny-button
        disabled={{@denyDisabled}}
        type="button"
        {{on "click" @onDeny}}
      >
        {{#unless @stickyBar}}
          {{svgJar "cross-small-red" width="16" height="16" class="flex-none mr-2 align-middle"}}
        {{/unless}}
        Deny
      </button>
    </div>
  </template>
}
